import React from 'react';

import { mergeLetterPdf } from '../generator/hooks/mergeLetterPdf';

import { DrawerPdfLetter, DrawerPdfLetterProps } from './DrawerPdfLetter';

export async function generateDrawerLetter(
  props: DrawerPdfLetterProps,
): Promise<File[]> {
  return mergeLetterPdf(<DrawerPdfLetter {...props} />, {
    hasFcra: props.hasFcra,
    openInNewTab: false,
    policyNumber: props.policyNumber,
    letterType: props.letterType,
  });
}
